import { createButton } from 'src/library/minigame_client/ui/common/ui'
import {lang} from "./library/lang";

export default class Help extends PIXI.Container
{
    constructor(configGame) {

        super();

        let self = this;

        const packFolder = configGame.packFolder;
        const pathRes = "res/" + configGame.pathFolder;
        const screen = configGame.Screen;

        const config = configGame.Help;

        this.sndBtnClick = sounds.get("res/sounds/btn_click");

        this.layerBlockInput = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.layerBlockInput.position.set(0, 0);
        this.layerBlockInput.interactive = true;     // block interactive of overlaid buttons
        this.layerBlockInput.width = screen.resolution.width;
        this.layerBlockInput.height = screen.resolution.height;
        this.layerBlockInput.tint = 0x000000;
        this.layerBlockInput.alpha = 0.7;
        this.addChild(this.layerBlockInput);

        this.background = new PIXI.Sprite(PIXI.utils.TextureCache[pathRes + "utility_background.png"]);
        this.background.position.set(config.background.pos.x, config.background.pos.y);
        this.background.interactive = true;     // block interactive of overlaid buttons
        this.addChild(this.background);

        this.backgroundTitle = new PIXI.Sprite(PIXI.utils.TextureCache[packFolder + "title_help.png"]);
        this.backgroundTitle.position.set(config.backgroundTitle.pos.x, config.backgroundTitle.pos.y);
        this.background.addChild(this.backgroundTitle);

        this.buttonOk = createButton(this.background, config.buttonOk.pos.x, config.buttonOk.pos.y, packFolder + "ok_info", this.sndBtnClick);

        const translateList = config.translateList;

        const lng = lang();

        this.labelTitle = new PIXI.Text(translateList.name[lng], config.labelTitle.font);
        this.labelTitle.position.set(config.labelTitle.pos.x, config.labelTitle.pos.y);
        this.labelTitle.anchor.set(0.5, 0.0);
        this.background.addChild(this.labelTitle);

        this.labelTitle0 = new PIXI.Text(translateList.mode[lng], config.labelTitle0.font);
        this.labelTitle0.position.set(config.labelTitle0.pos.x, config.labelTitle0.pos.y);
        this.labelTitle0.anchor.set(0.0, 0.0);
        this.background.addChild(this.labelTitle0);

        this.labelInfo = new PIXI.Text('\n\n' + translateList.info[lng], config.labelInfo.font);
        this.labelInfo.position.set(config.labelInfo.pos.x, config.labelInfo.pos.y);
        this.labelInfo.anchor.set(0.0, 0.0);
        this.background.addChild(this.labelInfo);

        // this.labelTitle1 = new PIXI.Text(translateList.mode1[lng], config.labelTitle1.font);
        // this.labelTitle1.position.set(config.labelTitle1.pos.x, config.labelTitle1.pos.y);
        // this.labelTitle1.anchor.set(0.0, 0.0);
        // this.background.addChild(this.labelTitle1);
        //
        // this.labelInfo1 = new PIXI.Text('\n\n' + translateList.info1[lng], config.labelInfo.font);
        // this.labelInfo1.position.set(config.labelInfo1.pos.x, config.labelInfo1.pos.y);
        // this.labelInfo1.anchor.set(0.0, 0.0);
        // this.background.addChild(this.labelInfo1);
    };

    terminate () {
        this.removeChildren();
        this.destroy();

        this.background = null;
        this.backgroundTitle = null;
        this.labelTitle = null;
        this.labelTitle0 = null;
        this.labelInfo = null;
        //this.labelTitle1 = null;
        //this.labelInfo1 = null;
        this.buttonOk = null;

        this.layerBlockInput = null;

        this.sndBtnClick.stop();
        this.sndBtnClick = null;
    }

    setOnButtonCloseEvent (func) {
        this.buttonOk.callback = function() {func();};
    }
}


// WEBPACK FOOTER //
// ./src/help.es6